import whoFundsTnCandidateSummaries from "../whofundstnCandidateSummaries2026.json";

export const WHO_FUNDS_TN_SOURCE = whoFundsTnCandidateSummaries.source;

const normalize = (value = "") =>
  value
    .toLowerCase()
    .replace(/["'.]/g, "")
    .replace(/\s+/g, " ")
    .trim();

const getDistrictOffice = (title, officeLabel) => {
  const match = title.match(/District\s+(\d+)/i);
  if (!match) return null;

  return `${officeLabel}, District ${match[1].padStart(2, "0")}`;
};

export const getWhoFundsOfficeForRace = (raceTitle = "") => {
  if (raceTitle === "Governor") return "Tennessee Governor";
  if (/^Tennessee Senate District/i.test(raceTitle)) {
    return getDistrictOffice(raceTitle, "Tennessee Senate");
  }
  if (/^Tennessee House District/i.test(raceTitle)) {
    return getDistrictOffice(raceTitle, "Tennessee House");
  }

  return null;
};

const summaryIndex = new Map(
  whoFundsTnCandidateSummaries.summaries.map((summary) => [
    `${normalize(summary.candidate)}::${normalize(summary.office)}`,
    summary,
  ])
);

export const getWhoFundsCandidateSummary = (candidateName, raceTitle) => {
  const office = getWhoFundsOfficeForRace(raceTitle);
  if (!office) return null;

  return summaryIndex.get(`${normalize(candidateName)}::${normalize(office)}`) || null;
};

export const getWhoFundsRaisedTotal = (summary) => {
  if (!summary) return null;

  const monetary = Number(summary.monetary_raised) || 0;
  const inkind = Number(summary.inkind_received) || 0;
  return monetary + inkind;
};
